module.exports = __webpack_public_path__ + "static/media/svg-10.65fe3fe5.svg";